import { Dispatch, SetStateAction } from "react";

import { TreePicklistItem } from "./TreePicklistItem";
import { SummaryState } from "./TreePicklistItemProvider";

export function updateIndeterminate(
    item: TreePicklistItem,
    newState: SummaryState,
    parentStatePatcher: Dispatch<SetStateAction<TreePicklistItem[]>>
) {
    parentStatePatcher(prev => {
        const filtered = prev.filter(prevItem => item.elementId !== prevItem.elementId);
        if (newState === SummaryState.Indeterminate) {
            return [...filtered, item];
        } else {
            return filtered;
        }
    });
}

export function patchTreeStructure(
    item: TreePicklistItem,
    newState: SummaryState,
    parentStatePatcher: Dispatch<SetStateAction<TreePicklistItem[]>>
) {
    parentStatePatcher(prev => {
        const isCurrentItemPicked = prev.filter(prevItem => item.elementId === prevItem.elementId).length === 1;
        if (isCurrentItemPicked) {
            if (newState === SummaryState.Checked) {
                return [...prev];
            } else {
                return prev.filter(prevItem => item.elementId !== prevItem.elementId);
            }
        } else {
            if (newState === SummaryState.Checked) {
                return [...prev, item];
            } else {
                return [...prev];
            }
        }
    });
}
